export default {
    SUMMARY_REPORT: "Отчёты",
    SAVE: "Сохранить",
    BACK: "Вернуться"
};
